<v2-center id="leading-icon-cont">
  <v2-icon icon="error-warning" color="white"></v2-icon>
</v2-center>

<v2-row id="text-cont" alignItems="center">
  <v2-body-header-3-text color="alert-orange">
    {{ toastRef.primaryText }}
  </v2-body-header-3-text>
</v2-row>
